// extracted by mini-css-extract-plugin
export default {"avatar":"Header_avatar__9t59A","headerRight":"Header_headerRight__1ZOXq","mainHeader":"Header_mainHeader__q+kXH","container":"Header_container__zmwVK"};